import { FormControlLabel, Checkbox } from '@mui/material'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'

/**
 * Renders a checkbox input wrapped in a FormControlLabel component.
 *
 * @author Maria Eduarda Franke
 * @param {string} props.name - The name of the checkbox input.
 * @param {string} props.label - The label text for the checkbox input.
 * @param {Object} props.control - The control object from react-hook-form.
 * @returns {JSX.Element} - The rendered checkbox input wrapped in a FormControlLabel component.
 */
const FormCheckbox = ({ name, label, labelPlacement = 'start', control, ...props }) => {

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <FormControlLabel
                    label={label}
                    labelPlacement={labelPlacement}
                    control={<Checkbox checked={field.value} {...field} />}
                    {...props}
                />
            )}
        />
    )
}

FormCheckbox.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    labelPlacement: PropTypes.string,
    control: PropTypes.object,
    errors: PropTypes.object
}

export default FormCheckbox